module.exports = __webpack_public_path__ + "static/icons/icon-chevron-right-7e5c569109363049d57aca679fafdc74.svg";